import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    standalone: true,
    imports: [TranslateModule, RouterModule]
})

export class LandingComponent {
    constructor(private router: Router) { }

    onBookServices() {
        // Replace current history entry so we get a single navigation (avoids double refresh)
        this.router.navigate(['/components/assignments'], { replaceUrl: true });
    }

    onJoinSafetly() {
        this.router.navigate(['/download'], { replaceUrl: true });
    }
} 